export default __webpack_public_path__ + "static/media/telegram.8d807597.svg";